import { extends as _extends, objectWithoutProperties as _objectWithoutProperties, defineProperty as _defineProperty, objectSpread as _objectSpread } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { marginBottomLevels, getMarginBottomClass } from '../../utils/marginBottom/index.js';
import isNumber from 'lodash/fp/isNumber';
import styles from './grid.css.js';

var Grid = function Grid(props) {
  return React.createElement("div", _extends({
    className: styles.Grid
  }, props));
};

Grid.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
var rowPropTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottomMedium: PropTypes.oneOf(marginBottomLevels),

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottomLarge: PropTypes.oneOf(marginBottomLevels)
} : {};

var Row = function Row(_ref) {
  var _cn;

  var marginBottom = _ref.marginBottom,
      marginBottomMedium = _ref.marginBottomMedium,
      marginBottomLarge = _ref.marginBottomLarge,
      rest = _objectWithoutProperties(_ref, ["marginBottom", "marginBottomMedium", "marginBottomLarge"]);

  return React.createElement("div", _extends({
    className: cn(styles.Row, (_cn = {}, _defineProperty(_cn, getMarginBottomClass(marginBottom), isNumber(marginBottom)), _defineProperty(_cn, getMarginBottomClass(marginBottomMedium, 'medium'), isNumber(marginBottomMedium)), _defineProperty(_cn, getMarginBottomClass(marginBottomLarge, 'large'), isNumber(marginBottomLarge)), _cn))
  }, rest));
};

Row.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread({}, rowPropTypes) : {};

var Cell = function Cell(_ref2) {
  var _cn2;

  var offset = _ref2.offset,
      offsetMedium = _ref2.offsetMedium,
      offsetLarge = _ref2.offsetLarge,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 12 : _ref2$size,
      sizeMedium = _ref2.sizeMedium,
      sizeLarge = _ref2.sizeLarge,
      marginBottom = _ref2.marginBottom,
      marginBottomMedium = _ref2.marginBottomMedium,
      marginBottomLarge = _ref2.marginBottomLarge,
      rest = _objectWithoutProperties(_ref2, ["offset", "offsetMedium", "offsetLarge", "size", "sizeMedium", "sizeLarge", "marginBottom", "marginBottomMedium", "marginBottomLarge"]);

  var classes = cn(styles.Cell, styles['size-' + size], (_cn2 = {}, _defineProperty(_cn2, styles['sizeMedium-' + sizeMedium], !!sizeMedium), _defineProperty(_cn2, styles['sizeLarge-' + sizeLarge], !!sizeLarge), _defineProperty(_cn2, styles['offset-' + offset], !!offset), _defineProperty(_cn2, styles['offsetMedium-' + offsetMedium], !!offsetMedium), _defineProperty(_cn2, styles['offsetLarge-' + offsetLarge], !!offsetLarge), _defineProperty(_cn2, getMarginBottomClass(marginBottom), isNumber(marginBottom)), _defineProperty(_cn2, getMarginBottomClass(marginBottomMedium, 'medium'), isNumber(marginBottomMedium)), _defineProperty(_cn2, getMarginBottomClass(marginBottomLarge, 'large'), isNumber(marginBottomLarge)), _cn2));
  return React.createElement("div", _extends({
    className: classes
  }, rest));
};

Cell.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread({}, rowPropTypes, {
  offset: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
  offsetLarge: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
  offsetMedium: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
  size: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  sizeLarge: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  sizeMedium: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])
}) : {};
export { Cell, Grid, Row };